import { useState } from "react";
import Table from "../../utils/utilities/Table/Table";

import InventoryRoundedIcon from '@mui/icons-material/InventoryRounded';

import { headers, filters, tabs } from "./config";

import PaymentStats from "./Components/Stats";

import useIsMobile from "../../hooks/useIsMobile";

import { TableTitle } from "../../utils/Common"

const PaymentList = () => {

  const { isMobile } = useIsMobile();

  return (
    <>
    <TableTitle><InventoryRoundedIcon /><span>Payment List</span></TableTitle>
    {!isMobile ? <PaymentStats tableId="payments" /> : null}
    <Table tableId="payments" title="Payment" icon={InventoryRoundedIcon} headers={headers} filters={filters} defaultSort="-date" idKey="payment_id" fieldsToSearch={["Customer", "Amount"]} tabs={tabs} tabField="method" NoTitle={true} exportCsv={true} />
    </>
  );
};

export default PaymentList;